// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".comp-claim[data-v-3f1f493a]{width:100%;background-color:#fff;margin-top:.2rem}.comp-claim .cont[data-v-3f1f493a]{width:100%}.comp-claim .cont .hd[data-v-3f1f493a]{height:1.14rem;line-height:1.14rem;padding:0 .3rem;font-size:.34rem;font-weight:500;color:#333}.comp-claim .cont img[data-v-3f1f493a]{display:block;width:100%;height:100%}.comp-claim .cont p[data-v-3f1f493a]{margin:0 .3rem;padding-bottom:.3rem;font-size:.26rem;color:#666;line-height:.4rem}", ""]);
// Exports
module.exports = exports;
